function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Logo");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "App-icon",
  transform: "translate(-81.000000, -48.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  transform: "translate(81.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M286.771981,296.743521 C295.452894,294.038562 303.971527,290.337884 312.176265,285.600876 C320.538019,280.773215 327.455132,273.955048 333.168184,265.798055 L312.263533,353.847609 L175,417.395544 L37.7364668,353.847609 L16.3494518,263.766342 C22.3188839,272.824349 29.6747018,280.377646 38.7216015,285.600876 C46.2881326,289.969415 54.1216247,293.456576 62.1031632,296.094211 L175,361.262627 L286.771981,296.743521 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.502027,51.0009631 C134.159116,21.3164389 176.688141,0.047814065 176.688141,0.047814065 C176.688141,0.047814065 223.759279,21.1263563 258.050041,53.0125582 C231.915399,45.6688 205.875534,43.59365 187.244201,54.350455 C183.135065,56.7228657 179.187271,59.3747287 175.415138,62.2760838 C171.643004,59.3747287 167.69521,56.7228657 163.586074,54.350455 C146.792011,44.6543979 123.978509,45.384313 100.502008,51.0009677 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.097037,81.6944574 C164.137445,78.4941156 159.95117,75.6036403 155.559851,73.068311 C106.949253,45.0029693 2.21882494,114.140025 2.21882494,114.140025 C2.21882494,114.140025 -10.3735934,236.472985 43.3201902,267.473105 C46.2368898,269.157063 49.1977309,270.695286 52.1942795,272.090034 L52.1942795,148.598007 L168.097037,81.6944574 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.805721,272.075434 C300.791569,270.684554 303.74193,269.151189 306.648457,267.473105 C360.34224,236.472985 347.749822,114.140025 347.749822,114.140025 C347.749822,114.140025 243.019394,45.0029693 194.408796,73.068311 C190.022306,75.6008522 185.840409,78.4877587 181.884674,81.6839003 L297.805721,148.598007 L297.805721,272.075434 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Polygon-2",
  transform: "translate(175.000000, 219.486214) scale(1, -1) translate(-175.000000, -219.486214) ",
  points: "175 114.841718 265.642318 167.163966 265.642318 271.808462 175 324.130709 84.3576825 271.808462 84.3576825 167.163966"
}))));

var SvgLogoWhite = function SvgLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "418px",
    viewBox: "0 0 350 418",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_white.b77f2e88.svg";
export { ForwardRef as ReactComponent };